<template>
  <v-app>
    <printables-core-view />
  </v-app>
</template>

<script>
  export default {
    name: 'PagesIndex',

    components: {
      PrintablesCoreView: () => import('./components/core/View'),
    },
  }
</script>

<style>
  @import '../../assets/gutenberg/gutenberg.css';
  @import '../../assets/gutenberg/themes/modern.css';
</style>
